var map = {
	"./Selected Students.xlsx": 5507,
	"./bhrama-kumari.jpeg": 2637,
	"./card1.png": 106,
	"./card2.png": 273,
	"./card4.png": 7575,
	"./client.png": 3624,
	"./client2.png": 3320,
	"./client3.png": 6033,
	"./client4.png": 9294,
	"./court-app.png": 6538,
	"./cwt.png": 7003,
	"./divya-gyan.jpeg": 8037,
	"./e_vyapari.png": 8435,
	"./evyapari.png": 9596,
	"./f-product2.png": 2691,
	"./f-product3.png": 5114,
	"./feature-project.png": 7683,
	"./food-app.jpg": 7479,
	"./joy.jpg": 4463,
	"./kavach.jpg": 9387,
	"./logo1.png": 3391,
	"./logo2.png": 1764,
	"./logo3.png": 1357,
	"./mamba.png": 393,
	"./project-a.png": 2400,
	"./project-b.png": 731,
	"./project-c.png": 6514,
	"./project-d.png": 9021,
	"./project-e.png": 9076,
	"./project-f.jpg": 9679,
	"./project-g.png": 7398,
	"./project-h.png": 9329,
	"./project-i.png": 1464,
	"./project-showcase.png": 1434,
	"./shinezilla.jpg": 3194,
	"./shinezilla.png": 3934,
	"./snackstar.png": 2699,
	"./ui1.png": 6862,
	"./ui2.png": 4213,
	"./ui3.png": 5116,
	"./ui4.png": 5283,
	"./ui5.png": 7706,
	"./ui6.png": 7873,
	"./web1.png": 5118,
	"./web2.png": 7541,
	"./web3.png": 28,
	"./web4.png": 9987,
	"./web5.png": 2874,
	"./web6.png": 8209,
	"./web7.png": 9144,
	"./web8.png": 7151,
	"./web9.png": 2054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5761;